var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 64,
    viewBox: "0 0 172 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0276 36.781C47.0276 36.781 44.0911 36.3716 45.2924 39.2375C46.4937 42.1034 52.2331 42.1034 52.3665 38.0093C52.5 33.9151 50.7648 28.7292 44.0911 30.9127C37.4174 33.0963 37.4174 41.0116 39.4195 43.6046C41.4216 46.1975 51.8326 52.8847 58.7733 42.1034C65.714 31.3222 52.233 19.7221 43.1568 22.8609C34.0805 25.8633 26.339 40.4657 35.6822 49.7458C45.0254 59.0258 59.3072 55.3412 64.1123 45.7882C65.4389 43.0753 66.152 39.9552 66.1904 36.781M66.1904 36.781C66.2873 28.7779 62.0949 20.4312 52.6335 17.402C39.4195 13.1714 27.1398 22.9974 25.8051 31.3221C24.4704 39.6469 25.8051 53.1576 36.483 58.8894C47.161 64.7577 170 62.1647 170 62.1647L144.616 36.781H66.1904Z",
    stroke: "#999999",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4365 18.6304L30.4767 2.79973C30.4767 2.79973 24.6039 -0.0661676 18.1971 1.43502C11.7904 2.9362 -3.55923 13.0351 2.31365 29.4117C8.05305 45.7882 33.6801 57.2518 33.6801 57.2518",
    stroke: "#999999",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoll);
export default __webpack_public_path__ + "static/media/roll.5a3d3e08131474425e611e904606a21a.svg";
export { ForwardRef as ReactComponent };